import createReactClass from 'create-react-class';
import PropTypes from 'prop-types';
// -*- mode: jsx;-*-
import { donorSupportCategoriesWithReferrerSelectInput, partnerReferrers } from './contactConstants.js';

export const PartnershipFields = createReactClass({
    propTypes: {
        formErrors: PropTypes.object.isRequired,
        chosenSupportCategory: PropTypes.object.isRequired,
        organizationName: PropTypes.string,
        partnerReferrer: PropTypes.string,
        wordOfMouthReferrer: PropTypes.string,
        handleInputChange: PropTypes.func.isRequired,
        handlePartnerReferrerChange: PropTypes.func.isRequired,
    },

    renderPartnerReferrerInput() {
        var options = partnerReferrers.map(function (referrer) {
            return <option key={referrer}
						   value={referrer}>{referrer}</option>;
        }, this);
        return (
            <div>
                <div className="input-holder" id="partnerWordOfMouth">
                    <label htmlFor="partnerWordOfMouthReferrer">How did you hear about DonorsChoose?</label>
                    <select id="partnerWordOfMouthReferrer"
                        className={this.props.formErrors.wordOfMouthReferrer ? 'hasError' : ''}
                        value={this.props.partnerReferrer}
                        onChange={this.props.handlePartnerReferrerChange}>
                        <option value="">Select one</option>
                        {options}
                    </select>
                </div>
            </div>
        );
    },

    renderWordOfMouthFields() {
        if (donorSupportCategoriesWithReferrerSelectInput[this.props.chosenSupportCategory.keyword]) {
            if (this.props.partnerReferrer === 'Other') {
                return (
                    <div>
                        {this.renderPartnerReferrerInput()}
                        <div className="input-holder">
                            <label htmlFor="wordOfMouthReferrer">If other, please specify:</label>
                            <input id="wordOfMouthReferrer" name="wordOfMouthReferrer" type="text" value={this.props.wordOfMouthReferrer} onChange={this.props.handleInputChange} />
                        </div>
                    </div>
                );
            } else {
                return (
                    <div>
                        {this.renderPartnerReferrerInput()}
                        <input type="hidden" id="wordOfMouthReferrer" name="wordOfMouthReferrer" value={this.props.wordOfMouthReferrer}/>
                    </div>
                );
            }
        } else {
            return (
                <div>
                    <div className="input-holder">
                        <label htmlFor="wordOfMouthReferrer">How did you hear about DonorsChoose? (optional)</label>
                        <input id="wordOfMouthReferrer" name="wordOfMouthReferrer" type="text" value={this.props.wordOfMouthReferrer} onChange={this.props.handleInputChange} />
                    </div>
                </div>
            );
        }
    },

    render() {
        return (<div>
            <div className="input-holder">
                <label htmlFor="organizationName">Organization name and website</label>
                <input id="organizationName" name="organizationName" className={this.props.formErrors.organizationName ? 'hasError' : ''} type="text" value={this.props.organizationName} onChange={this.props.handleInputChange} placeholder="Company Name / www.company.com" />
                {this.props.formErrors.organizationName ? (<div className="error-text">{this.props.formErrors.organizationName}</div>) : null}
            </div>
            {this.renderWordOfMouthFields()}
        </div>
        );
    },
});
